import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition, SizeProp } from '@fortawesome/fontawesome-svg-core'

export interface IconProps {
  icon: IconDefinition
  className?: string
  size?: SizeProp
}

export const Icon: React.FC<IconProps> = ({ icon, className, size }) => {
  return <FontAwesomeIcon icon={icon} className={className} size={size} />
}
